import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import env from '../../util/env';
import styled from 'styled-components';
import {currentResource, labels} from '../../util/utils';
import utilityfunctions from '../../util/utilityfunctions';
import {serviceURL, adminUserTabs, displayLanguageListItems, promiseAreas} from '../../util/uiconstants';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import MotifSearch from '../Common/Search/MotifSearch';
import {
	getAdminUser,
	getAdminUserClient,
	getAdminUserProject,
	getAdminUserOtherProject,
	setAdminUserActiveTab,
	clearAdminUser,
	setIsUnsavedUserDataModalOpen
} from '../../actions/AdminUser/AdminUserAction';
import {deleteMember} from '../../actions/AccessGroups/Addmemberactions';
import CustomTable from '@ey/canvascoreservices/CustomTable';
import TabBar from './../Common/TabBar/TabBar';
import {actionIcDelete24px} from '@ey/motif-react-wrapper/assets/icons';
import TrackerLoader from './../Common/LoadingIndicator/TrackerLoader';
import {raiseJSValidationError, clearErrors} from '../../actions/erroractions';
import {Buffer} from 'buffer';
import Button from '../CoreWrappers/Button';

const ManageUsers = (props) => {
	const userPreferences = useSelector((store) => store.userPreferences);
	const user = useSelector((store) => store.adminUser);
	const userProject = useSelector((store) => store.adminUserProject);
	const userOtherProject = useSelector((store) => store.adminUserOtherProject);
	const userClient = useSelector((store) => store.adminUserClient);
	const adminUserActiveTab = useSelector((state) => state.adminUserActiveTab);
	const [searchUser, setSearchUser] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const [showNoResultMessage, setShowNoResultMessage] = useState(false);
	const dispatch = useDispatch();
	const [userDetails, setUserDetails] = useState([]);
	const [userSetting, setUserSetting] = useState({});
	const [delegateFrom, setDelegateFrom] = useState([]);
	const [delegateTo, setDelegateTo] = useState([]);
	const [accessibleProject, setAccessibleProject] = useState([]);
	const [otherProject, setOtherProject] = useState([]);
	const [clients, setClients] = useState([]);
	const [deletedAccessibleProject, setDeletedAccessibleProject] = useState([]);

	useEffect(() => {
		setSearchUser('');
		resetState();
		return () => {
			dispatch(setIsUnsavedUserDataModalOpen(false));
		};
	}, []);

	useEffect(() => {
		if (
			userPreferences.isPreferencesLoaded &&
			(!userPreferences.userType === 'Admin' ||
				(!userPreferences.isAdminReader && !userPreferences.isAdminWriter && !userPreferences.isSuperAdmin))
		) {
			// this is to let the current resource acquire the language first and then display the message
			setTimeout(() => {
				dispatch(raiseJSValidationError(currentResource.AdminUserErrors.userError));
			}, 900);
		}
	}, [userPreferences]);

	useEffect(() => {
		let delegatedFrom = [];
		let delegatedTo = [];
		let userData = [];
		let userSetting = {};
		if (!user?.gui && !_.isEmpty(searchUser)) {
			resetState();
			setShowNoResultMessage(true);
		} else if (!_.isEmpty(searchUser) && user && user.gui) {
			setShowNoResultMessage(false);
			userData = [{gui: user.gui, firstName: user.firstName, lastName: user.lastName, emailAddress: user.emailAddress}];
			userSetting = {
				theme: user.theme ? (user.theme?.toLowerCase() == labels.dark.toLowerCase() ? labels.dark : labels.light) : '',
				status: user.isDeleted ? labels.inActive : labels.active,
				language: user.languageISOCode
					? displayLanguageListItems.find((x) => x.languageISOCode === user.languageISOCode).label
					: '',
				timeZoneISOCode: user.timeZoneISOCode,
				numberFormat: user.numberFormat,
				dateFormat: user.dateFormat
			};
			setUserDetails(userData);
			setUserSetting(userSetting);

			if (_.size(user.delegatedFrom) > 0) {
				delegatedFrom = user.delegatedFrom.map(({userId, firstName, lastName, emailAddress}) => {
					return {userId, firstName, lastName, emailAddress};
				});
			}
			setDelegateFrom(delegatedFrom);

			if (_.size(user.delegatedTo) > 0) {
				delegatedTo = user.delegatedTo.map(({userId, firstName, lastName, emailAddress}) => {
					return {userId, firstName, lastName, emailAddress};
				});
			}
			setDelegateTo(delegatedTo);
		}
	}, [user]);

	useEffect(() => {
		accessibleProjectSetter();
	}, [userProject]);

	useEffect(() => {
		let otherProject = [];
		if (userOtherProject && _.size(userOtherProject) > 0) {
			otherProject = utilityfunctions.sortListData([...userOtherProject], 'name');
		}
		setOtherProject(otherProject);
	}, [userOtherProject]);

	useEffect(() => {
		let clients = [];
		if (userClient && _.size(userClient) > 0) {
			userClient.map((c) => {
				let dataObject = {};
				dataObject.clientName = c.clientName;
				dataObject.source = c.sources.join(', ');
				const delegatedFromUsers = c.userIds.filter((userId) => userId !== user.gui);
				dataObject.delegate = _.size(delegatedFromUsers) > 0 ? labels.yes : '';
				clients.push(dataObject);
			});
		}
		setClients(clients);
	}, [userClient]);

	useEffect(() => {
		if (adminUserActiveTab) {
			if (user && user.gui) {
				if (
					adminUserActiveTab === adminUserTabs.otherProjects &&
					!_.isEmpty(searchUser) &&
					_.size(otherProject) === 0
				) {
					const requestUserOtherProjectUrl =
						env.getBaseURL(serviceURL) + 'users/' + searchUser + '/Projects?includeOtherProjects=true';
					dispatch(getAdminUserOtherProject(requestUserOtherProjectUrl)).finally();
				}
				if (adminUserActiveTab === adminUserTabs.clients && !_.isEmpty(searchUser) && _.size(clients) === 0) {
					const requestUserClientUrl = env.getBaseURL(serviceURL) + 'users/' + searchUser + '/clients';
					dispatch(getAdminUserClient(requestUserClientUrl)).finally();
				}
			}
		}
	}, [adminUserActiveTab]);

	useEffect(() => {
		if (_.size(deletedAccessibleProject) > 0) {
			dispatch(setIsUnsavedUserDataModalOpen(true));
		} else {
			dispatch(setIsUnsavedUserDataModalOpen(false));
		}
	}, [deletedAccessibleProject]);

	const handlerSearch = (searchString) => {
		if (!searchString || _.size(searchString.searchUser) === 0) {
			setErrorMessage(labels.validGuiErrorMsg);
		} else {
			let apiCalls = [];
			resetState();
			setSearchUser(searchString.searchUser);
			const requestUserUrl = env.getBaseURL(serviceURL) + 'users/' + searchUser;
			const requestUserProjectUrl = env.getBaseURL(serviceURL) + 'users/' + searchUser + '/projects?filter=default';
			apiCalls.push(
				Promise.resolve(
					dispatch(
						getAdminUser(requestUserUrl, {
							supressErrorOnUi: true
						})
					)
				)
			);
			apiCalls.push(
				Promise.resolve(
					dispatch(
						getAdminUserProject(requestUserProjectUrl, {
							supressErrorOnUi: true
						})
					)
				)
			);
			Promise.all(apiCalls).finally();
		}
	};

	const handlerClearSearch = () => {
		if (!_.isEmpty(searchUser)) {
			setSearchUser('');
			resetState();
		}
	};

	const handlerOnSearch = (value) => {
		let IsInvalidstring = false;
		setErrorMessage('');
		setShowNoResultMessage(false);
		if (value) {
			if (value.length <= 0) {
				IsInvalidstring = true;
			} else if (isNaN(value)) {
				IsInvalidstring = true;
			} else if (value.length > 50) {
				IsInvalidstring = true;
			}
		}
		if (IsInvalidstring) {
			setSearchUser('');
			setErrorMessage(labels.validGuiErrorMsg);
		} else {
			setSearchUser(value);
			setErrorMessage('');
		}
	};

	const removeProjectItem = (value) => {
		if (userPreferences && (userPreferences.isAdminWriter || userPreferences.isSuperAdmin)) {
			const deletedProject = accessibleProject && accessibleProject.filter((item) => item.projectId === value);
			const deletedProjects = [...deletedAccessibleProject, deletedProject];
			setDeletedAccessibleProject(deletedProjects);
			const updatedAccessibleProjectList =
				accessibleProject && accessibleProject.filter((item) => item.projectId !== value);
			setAccessibleProject(updatedAccessibleProjectList);
			console.log('removing project: ' + value);
		}
	};

	const saveUpdatedAccessibleProject = () => {
		let promises = [];
		let errors = [];
		if (_.size(deletedAccessibleProject) > 0) {
			// API call
			let userId = user.gui;
			let buff = new Buffer(userId);
			let base64UserId = buff.toString('base64');
			deletedAccessibleProject.map((project) => {
				const projectMembers = project[0];
				let groupsToDeleteMember = [];
				if (_.size(projectMembers.groups) > 0) {
					const associatedGroups = projectMembers.groups;
					associatedGroups.map((group) => {
						if (group.users && group.users.some((u) => u.userId == userId)) {
							console.log(
								'removing user: ' + userId + ' group: ' + group.accessGroupId + ' project: ' + projectMembers.projectId
							);
							groupsToDeleteMember.push(group.accessGroupId);
						}
					});
				}
				if (_.size(groupsToDeleteMember)) {
					_.forEach(groupsToDeleteMember, (groupToDeleteMember) => {
						const url = `${env.getBaseURL(serviceURL)}Projects/${
							projectMembers.projectId
						}/Groups/${groupToDeleteMember}/Users/${base64UserId}`;

						promises.push(
							Promise.resolve(
								dispatch(deleteMember(url)).catch((error) => {
									var projectError = {projectName: projectMembers.name, errorObj: error};
									errors.push(projectError);
								})
							)
						);
					});
				}
			});

			if (_.size(promises) > 0) {
				Promise.all(promises)
					.then(() => {
						let errorMessages = '';
						if (_.size(errors) > 0) {
							_.forEach(errors, (error) => {
								let displayError = utilityfunctions.getErrorFromResponse(error.errorObj);
								let errorCodeFromApi = utilityfunctions.getErrorCodeFromResponse(displayError);
								let errorMessage = utilityfunctions.getErrorMessageFromResponse(displayError);

								if (!_.isEmpty(errorMessage)) {
									if (errorCodeFromApi === 330) {
										errorMessage = errorMessage + ': ' + error.projectName;
										errorMessages += errorMessage + '\n';
									}
								}
							});

							if (!_.isEmpty(errorMessages)) {
								dispatch(clearErrors()).then(() => {
									errorMessages.split('\n').map((str) => {
										if (str.length > 0) {
											dispatch(raiseJSValidationError(str));
										}
									});
								});
							}
						}
					})
					.finally(() => {
						setDeletedAccessibleProject([]);
						reloadAccessibleProject();
					});
			}
		}
	};

	const revertChangesForAccessibleProject = () => {
		if (_.size(deletedAccessibleProject) > 0) {
			setDeletedAccessibleProject([]);
			accessibleProjectSetter();
			console.log('Changes has reverted');
		}
	};

	const accessibleProjectSetter = () => {
		let accessibleProject = [];
		if (userProject && _.size(userProject) > 0) {
			accessibleProject = utilityfunctions.sortListData([...userProject], 'name');
		}
		setAccessibleProject(accessibleProject);
	};

	const resetState = () => {
		dispatch(clearAdminUser());
		dispatch(setAdminUserActiveTab(adminUserTabs.accessibleProjects));
		setUserDetails([]);
		setUserSetting({});
		setDelegateTo([]);
		setDelegateFrom([]);
		setClients([]);
		setAccessibleProject([]);
		setOtherProject([]);
		setDeletedAccessibleProject([]);
		setErrorMessage('');
		setShowNoResultMessage(false);
	};

	const managerUserTabs = [
		{
			id: adminUserTabs.accessibleProjects,
			label: labels.accessibleProjects
		},
		{
			id: adminUserTabs.otherProjects,
			label: labels.otherProjectsTabTitle
		},
		{
			id: adminUserTabs.clients,
			label: labels.clientNameLbl
		},
		{
			id: adminUserTabs.delegates,
			label: labels.delegates
		},
		{
			id: adminUserTabs.userSettings,
			label: labels.usersettings
		}
	];

	const reloadAccessibleProject = () => {
		const requestUserProjectUrl = env.getBaseURL(serviceURL) + 'users/' + searchUser + '/projects?filter=default';
		dispatch(getAdminUserProject(requestUserProjectUrl)).finally();
	};

	const tableColumnsUser = [
		{
			label: labels.gui,
			sortable: false,
			propName: 'gui',
			width: '25%'
		},
		{
			label: labels.firstName,
			sortable: false,
			propName: 'firstName',
			width: '25%'
		},
		{
			label: labels.lastName,
			sortable: false,
			propName: 'lastName',
			width: '25%'
		},
		{
			label: labels.emailAddress,
			sortable: false,
			propName: 'emailAddress',
			width: '25%'
		}
	];

	const tableColumnsProject = [
		{
			label: labels.projectName,
			sortable: true,
			propName: 'name',
			customCellRender: (item) => {
				const result = (
					<Link
						className="project-name ellipsis"
						target="_blank"
						to={'/admin/manageprojects?projectId=' + item.projectId}
						title={item.name}
					>
						{item.name}
					</Link>
				);
				return result;
			},
			width: '40%'
		},
		{
			label: labels.projectID,
			sortable: true,
			propName: 'projectId',
			width: '35%'
		},
		{
			label: labels.projectStatus,
			sortable: true,
			propName: 'status',
			customCellRender: (item) => {
				return currentResource.ProjectStatusLabels.find((x) => x.value.toLowerCase() === item.status.toLowerCase())
					?.label;
			},
			width: '20%'
		},
		{
			label: '',
			sortable: false,
			propName: '',
			customCellRender: (item) => {
				const result = (
					<MotifIcon
						id=""
						className="remove-row"
						onClick={() => removeProjectItem(item.projectId)}
						src={actionIcDelete24px}
						title={labels.remove}
					/>
				);
				return result;
			},
			width: '5%'
		}
	];

	const tableColumnsOtherProject = [
		{
			label: labels.projectName,
			sortable: true,
			propName: 'name',
			customCellRender: (item) => {
				const result = (
					<Link
						target="_blank"
						className="project-name ellipsis"
						to={'/admin/manageprojects?projectId=' + item.projectId}
						title={item.name}
					>
						{item.name}
					</Link>
				);
				return result;
			},
			width: '40%'
		},
		{
			label: labels.projectID,
			sortable: true,
			propName: 'projectId',
			width: '30%'
		},
		{
			label: labels.projectStatus,
			sortable: true,
			propName: 'status',
			customCellRender: (item) => {
				return currentResource.ProjectStatusLabels.find((x) => x.value.toLowerCase() === item.status.toLowerCase())
					?.label;
			},
			width: '25%'
		}
	];

	const tableColumnsClient = [
		{
			label: labels.clientName,
			sortable: true,
			propName: 'clientName',
			width: '50%'
		},
		{
			label: labels.source,
			sortable: true,
			propName: 'source',
			width: '30%'
		},
		{
			label: labels.delegateMember,
			sortable: true,
			propName: 'delegate',
			width: '20%'
		}
	];

	const tableColumnsDelegate = [
		{
			label: labels.userID,
			sortable: true,
			propName: 'userId',
			width: '25%'
		},
		{
			label: labels.firstName,
			sortable: true,
			propName: 'firstName',
			width: '25%'
		},
		{
			label: labels.lastName,
			sortable: true,
			propName: 'lastName',
			width: '25%'
		},
		{
			label: labels.emailAddress,
			sortable: true,
			propName: 'emailAddress',
			width: '25%'
		}
	];

	return (
		<>
			{(userPreferences.isAdminReader || userPreferences.isAdminWriter || userPreferences.isSuperAdmin) && (
				<StyledManageUsersSection>
					<section className="admin-users-wrapper customScrollbar">
						<section className="mainResponsiveWrapper">
							<header>
								<h3 className="ellipsis">{utilityfunctions.removeTags(labels.manageUsersTitle)}</h3>
							</header>
							<p className="instructional-text ellipsis">{labels.manageUsersInstructionalText}</p>
							<section className="search-wrap">
								<MotifSearch
									styleName="manage-search"
									value={searchUser}
									placeholder={labels.search}
									id={'search-manage-users'}
									searchHoverText={labels.search}
									onChange={(event) => handlerOnSearch(event.target.value)}
									onSearchButtonClick={handlerSearch}
									onClear={handlerClearSearch}
									onEnter={() => handlerSearch({searchUser})}
								/>
								{errorMessage && errorMessage.length > 0 && <MotifErrorMessage>{errorMessage}</MotifErrorMessage>}
								{showNoResultMessage && <section className="no-records-msg">{labels.noResultMessage}</section>}
							</section>
							<TrackerLoader
								areas={[promiseAreas.GET_MANAGE_USER]}
								view="__"
								styleName="CopyGroupLoader"
								fullscreen={false}
							/>
							<section className="user-details-wrap">
								<header>
									<h4>{labels.userDetails}</h4>
								</header>
								<CustomTable
									columns={tableColumnsUser}
									className="user-details-table"
									items={userDetails}
									showAccordions={false}
									hoverShadow={false}
									showNoResultFoundMessage={false}
									theme={utilityfunctions.getMotifTheme()}
									noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
									searchConfig={{
										disabled: true
									}}
									sortConfig={{
										sortBy: 'name',
										sortIsAscending: true
									}}
									paginationConfig={{disabled: true}}
								/>
							</section>
							<TabBar
								badge
								activeTab={adminUserActiveTab}
								onTabChange={(e) => {
									dispatch(setAdminUserActiveTab(e));
								}}
								tabs={managerUserTabs}
								styleName="manage-users-tabbar"
							/>
							<TrackerLoader
								areas={[promiseAreas.USER_PROJECTS_AREA]}
								view="__"
								styleName="CopyGroupLoader"
								fullscreen={false}
							/>
							{adminUserActiveTab === adminUserTabs.accessibleProjects && (
								<section>
									<CustomTable
										columns={tableColumnsProject}
										className="tabs-proj-table accessible-proj"
										items={accessibleProject}
										showAccordions={false}
										hoverShadow={false}
										showNoResultFoundMessage={false}
										theme={utilityfunctions.getMotifTheme()}
										noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
										searchConfig={{
											disabled: true
										}}
										sortConfig={{
											sortBy: 'name',
											sortIsAscending: true
										}}
										paginationConfig={{
											disabled: accessibleProject.length > 20 ? false : true,
											currentPage: 1,
											pageSize: 20,
											showMoreLabel: '',
											option: [20]
										}}
									/>
								</section>
							)}
							{adminUserActiveTab === adminUserTabs.otherProjects && (
								<section>
									<TrackerLoader
										areas={[promiseAreas.OTHER_PROJECTS_AREA]}
										view="__"
										styleName="CopyGroupLoader"
										fullscreen={false}
									/>
									<CustomTable
										columns={tableColumnsOtherProject}
										className="tabs-proj-table"
										items={otherProject}
										showAccordions={false}
										hoverShadow={false}
										showNoResultFoundMessage={false}
										theme={utilityfunctions.getMotifTheme()}
										noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
										searchConfig={{
											disabled: true
										}}
										sortConfig={{
											sortBy: 'name',
											sortIsAscending: true
										}}
										paginationConfig={{
											disabled: otherProject.length > 20 ? false : true,
											currentPage: 1,
											pageSize: 20,
											showMoreLabel: '',
											option: [20]
										}}
									/>
								</section>
							)}
							{adminUserActiveTab === adminUserTabs.clients && (
								<section>
									<CustomTable
										columns={tableColumnsClient}
										className="tabs-proj-table"
										items={clients}
										showAccordions={false}
										hoverShadow={false}
										showNoResultFoundMessage={false}
										theme={utilityfunctions.getMotifTheme()}
										noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
										searchConfig={{
											disabled: true
										}}
										sortConfig={{
											sortBy: 'clientName',
											sortIsAscending: true
										}}
										paginationConfig={{
											disabled: clients.length > 20 ? false : true,
											currentPage: 1,
											pageSize: 20,
											showMoreLabel: '',
											option: [20]
										}}
									/>
								</section>
							)}
							{adminUserActiveTab === adminUserTabs.delegates && (
								<section>
									<header>
										<h4 className="delegate-to-header">{labels.delegateTo}:</h4>
									</header>
									<CustomTable
										columns={tableColumnsDelegate}
										items={delegateTo}
										className="tabs-proj-table delegate-to-table"
										showAccordions={false}
										hoverShadow={false}
										showNoResultFoundMessage={false}
										theme={utilityfunctions.getMotifTheme()}
										noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
										searchConfig={{
											disabled: true
										}}
										sortConfig={{
											sortBy: 'firstName',
											sortIsAscending: true
										}}
										paginationConfig={{
											disabled: delegateTo.length > 20 ? false : true,
											currentPage: 1,
											pageSize: 20,
											showMoreLabel: '',
											option: [20]
										}}
									/>
									<header>
										<h4>{labels.delegateFrom}:</h4>
									</header>
									<CustomTable
										columns={tableColumnsDelegate}
										items={delegateFrom}
										className="tabs-proj-table delegate-from-table"
										showAccordions={false}
										hoverShadow={false}
										showNoResultFoundMessage={false}
										theme={utilityfunctions.getMotifTheme()}
										noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
										searchConfig={{
											disabled: true
										}}
										sortConfig={{
											sortBy: 'firstName',
											sortIsAscending: true
										}}
										paginationConfig={{
											disabled: delegateFrom.length > 20 ? false : true,
											currentPage: 1,
											pageSize: 20,
											showMoreLabel: '',
											option: [20]
										}}
									/>
								</section>
							)}
							{adminUserActiveTab === adminUserTabs.userSettings && (
								<section className="user-settings-wrap">
									<section className="col-1">
										<section className="display-lang-wrap">
											<section className="label-wrap">
												<section title={labels.displayLanguage} className="display-lang-label ellipsis">
													{labels.displayLanguage}
												</section>
												:
											</section>
											<section title={userSetting?.language} className="display-lang-value ellipsis">
												{userSetting?.language}
											</section>
										</section>
										<section className="date-format-wrap">
											<section className="label-wrap">
												<section title={labels.dateFormat} className="date-format-label ellipsis">
													{labels.dateFormat}
												</section>
												:
											</section>
											<section title={userSetting?.dateFormat} className="date-format-value ellipsis">
												{userSetting?.dateFormat}
											</section>
										</section>
										<section className="number-format-wrap">
											<section className="label-wrap">
												<section title={labels.numberFormat} className="number-format-label ellipsis">
													{labels.numberFormat}
												</section>
												:
											</section>
											<section title={userSetting?.numberFormat} className="number-format-value ellipsis">
												{userSetting?.numberFormat}
											</section>
										</section>
										<section className="time-zone-wrap">
											<section className="label-wrap">
												<section title={labels.timezone} className="time-zone-label ellipsis">
													{labels.timezone}
												</section>
												:
											</section>
											<section title={userSetting?.timeZoneISOCode} className="time-zone-value ellipsis">
												{userSetting?.timeZoneISOCode}
											</section>
										</section>
									</section>
									<section className="col-2">
										<section className="theme-wrap">
											<section className="label-wrap">
												<section title={labels.theme} className="theme-label ellipsis">
													{labels.theme}
												</section>
												:
											</section>
											<section title={userSetting?.theme} className="theme-value ellipsis">
												{userSetting?.theme}
											</section>
										</section>
									</section>
									<section className="col-3">
										<section className="status-wrap">
											<section className="label-wrap">
												<section title={labels.status} className="status-label ellipsis">
													{labels.status}
												</section>
												:
											</section>
											<section title={userSetting?.status} className="status-value ellipsis">
												{userSetting?.status}
											</section>
										</section>
									</section>
								</section>
							)}
						</section>
					</section>
					{userPreferences && (userPreferences.isAdminWriter || userPreferences.isSuperAdmin) && (
						<section className="footer-wrap">
							<Button
								onClick={() => saveUpdatedAccessibleProject()}
								variant={'primary-alt'}
								title={labels.save}
								label={labels.save}
							/>
							<Button
								onClick={() => revertChangesForAccessibleProject()}
								variant={'secondary'}
								title={labels.revertChanges}
								label={labels.revertChanges}
							/>
						</section>
					)}
				</StyledManageUsersSection>
			)}
		</>
	);
};

export default ManageUsers;
const StyledManageUsersSection = styled.section`
	position: relative;
	width: 100%;
	height: 100%;
	.admin-users-wrapper {
		width: 100%;
		height: calc(100% - 11.5rem);
		margin-top: 5rem;
		margin-bottom: 6rem;
	}

	header {
		width: 100%;
		h3 {
			margin-bottom: 0;
		}

		h4 {
			margin: 0;
			&.delegate-to-header {
				margin-top: 3rem;
			}
		}
	}

	.project-name {
		max-width: 100%;
		text-align: left;
	}
	.empty-container {
		background: ${(props) => props.theme.color[`whiteblack`]};
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		text-align: center;
		font-size: 1.4rem;
		padding: 1.5rem 0;
		color: ${(props) => props.theme.color[`grey400`]};
	}
	.manage-users-tabbar {
		padding: 0;
		.motif-tab-bar {
			border-bottom: 0;
		}
	}
	.instructional-text {
		font-size: 1.4rem;
	}
	.search-wrap {
		margin-bottom: 3rem;

		.motif-error-message {
			font-size: 1.2rem;
			svg {
				width: 1.5rem;
				height: 1.5rem;
			}
		}

		.no-records-msg {
			font-size: 1.4rem;
			margin-top: 1rem;
		}
	}
	.manage-search {
		width: 20%;
		.motif-input {
			font-size: 1.4rem;
			&::placeholder {
				font-size: 1.4rem;
			}
		}
	}

	.remove-row {
		align-items: center;
		display: flex;
	}

	.tabs-proj-table,
	.user-details-table {
		margin-top: 2rem;
		width: 80%;

		.list-body {
			div {
				&:last-child {
					.table-row {
						border-bottom: 0;
					}
				}
			}
		}

		.motif-card {
			border: solid 1px ${(props) => props.theme.color[`grey300`]};
		}
		.empty-container,
		.table-row,
		.row-cell-0,
		.row-cell-1,
		.row-cell-2,
		.row-cell-3,
		.row-cell-4,
		.table-header-item {
			font-size: 1.4rem;
		}
	}

	.manage-users-tabbar {
		margin-top: 2rem;
	}

	.show-more-label,
	.motif-pagination .motif-dropdown-trigger {
		visibility: hidden;
	}

	.tabs-proj-table {
		margin-bottom: 3rem;
		.sorting-icons {
			margin-top: 0.5rem;
		}
		.list-body {
			max-height: 50rem;
		}

		&.delegate-to-table,
		&.delegate-from-table {
			margin-top: 1.5rem;
		}

		a {
			color: ${(props) => props.theme.color[`blue600yellow400`]};
		}

		&.accessible-proj {
			.row-cell-3 {
				justify-content: center;
				padding-right: 0;
			}
		}

		&.accessible-proj {
			.row-cell-3 {
				justify-content: center;
				padding-right: 0;
			}
		}
	}

	.user-settings-wrap {
		margin: 3rem 0;
		display: flex;
		font-size: 1.4rem;

		.col-1 {
			width: 30%;
		}
		.col-2 {
			width: 20%;
		}
		.col-3 {
			width: 30%;
		}

		.display-lang-wrap,
		.date-format-wrap,
		.number-format-wrap,
		.time-zone-wrap,
		.theme-wrap,
		.status-wrap {
			display: flex;
			flex-direction: column;
			margin-bottom: 1rem;
			line-height: 2rem;
			max-width: 80%;
		}
		.display-lang-label,
		.date-format-label,
		.number-format-label,
		.time-zone-label,
		.theme-label,
		.status-label {
			font-weight: bold;
			max-width: 100%;
		}
		.display-lang-value,
		.date-format-value,
		.number-format-value,
		.time-zone-value,
		.theme-value,
		.status-value {
			max-width: 100%;
		}

		.label-wrap {
			display: flex;
			align-items: center;
		}
	}

	.footer-wrap {
		border-top: solid 1px ${(props) => props.theme.color[`grey300`]};
		position: absolute;
		bottom: 0;
		width: 100%;
		padding: 1.5rem 2rem 1.5rem 1.8rem;

		button {
			font-size: 1.4rem;
			font-weight: 700 !important;
			padding: 0.5rem 2rem;
			margin-right: 2rem;
			max-width: 20rem;
		}
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
